// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RefreshOutlinedSvg from "@fishx/icons-svg/es/asn/RefreshOutlined";
import FishxIcon from '../components/FishxIcon';

var RefreshOutlined = function RefreshOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RefreshOutlinedSvg
  }));
};

RefreshOutlined.displayName = 'RefreshOutlined';
export default React.forwardRef(RefreshOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RefreshOutlined.js
// module id = 3998
// module chunks = 0